import { gql } from "@/apis/nannyml";

export const sendTestEmail = gql(/* GraphQL */ `
  query SendTestEmail($smtpSettings: EmailSmtpSettingsInput!, $recipient: String!) {
    send_test_email(settings: $smtpSettings, recipient: $recipient)
  }
`);
